


























import { Component, Ref, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import { modalErrorStore } from '@/store'
import { audioNotify } from '@/utils'

@Component({
  components: {
    ModalFooter
  }
})
export default class ModalError extends ComponentVue {
  @Ref()
  modalFooter!: ModalFooter

  get isOpen(): boolean {
    return modalErrorStore.isOpen
  }

  get messages(): string[] {
    if (modalErrorStore.errorMessage === null) return []
    return modalErrorStore.errorMessage.messages()
  }

  @Watch('isOpen')
  initialize(newVal: boolean): void {
    if (newVal) {
      setTimeout(() => {
        audioNotify()
        this.modalFooter.focusOkButton()
      })
    }
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-error')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onClickOk(): void {
    modalErrorStore.ok()
  }
}
